import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=2aff21cd&scoped=true"
import script from "./TestimonialCard.vue?vue&type=script&lang=ts"
export * from "./TestimonialCard.vue?vue&type=script&lang=ts"
import style0 from "./TestimonialCard.vue?vue&type=style&index=0&id=2aff21cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff21cd",
  null
  
)

export default component.exports